<template>
  <div class="page-header clear-filter" filter-color="orange">
    <div class="page-header-image" style="background-image: url('img/login.jpg')"></div>
    <div class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <card type="login" plain>
            <div slot="header" class="w-50 mb-3 mx-auto">
              <img  v-lazy="'img/logo2.png'" alt />
            </div>
            <div class="notice-box">{{this.notice}}</div>
            <ValidationObserver v-slot="{ invalid }">
              <TextInput
                :rules="'required|companyName'"
                placeholder="Company Name"
                v-model="form.company_name"
              />
              <TextInput
                :rules="'required|email|companyEmail'"
                placeholder="Company Email"
                v-model="form.company_email"
              />
              <TextInput
                type="password"
                :rules="{'regex':/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,'required':true}"
                vid="confirmation"
                name="confirmation"
                placeholder="Password"
                v-model="form.password"
              />
              <TextInput
                type="password"
                :rules="'required|confirmed:confirmation'"
                placeholder="Confirm Password"
                v-model="form.cPassword"
              />
              <p v-if="errors" class="error-block bg-red">{{errors}}</p>
              <div class="card-footer text-center">
                <Botton
                  buttonClass="btn btn-primary btn-round btn-lg btn-block"
                  :disabled="invalid"
                  :isLoading="isLoggingIn"
                  text="Sign Up"
                  :onclick="signUp"
                />
              </div>
              <div class="pull-left">
                <h6>
                  <a href="/" class="link footer-link">Login</a>
                </h6>
              </div>
              <div class="pull-right">
                <h6>
                  <a href="#pablo" class="link footer-link"></a>
                </h6>
              </div>
            </ValidationObserver>

            
          </card>
        </div>
      </div>
    </div>
    <!-- <main-footer></main-footer> -->
  </div>
</template>
<script>
import { Card, Button, FormGroupInput } from "@/components";
import TextInput from "./components/Inputs/TextInput";
import { auth } from "../Firebase/firebase";
import { ValidationObserver } from "vee-validate";
import Botton from "./components/Botton";

//import MainFooter from '@/layout/MainFooter';
export default {
  name: "login-page",
  bodyClass: "login-page",
  components: {
    Card,
    //MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    TextInput,
    ValidationObserver,
    Botton
  },
  data() {
    return {
      form: {},
      notice: ""
    };
  },
  validations() {
    return {
      [this.form.company_name]: {}
    };
  },
  methods: {
    signUp() {
      this.$store.dispatch("Auth/signup", this.form).then(() => {
        //this.$router.push("/dashboard");
      });
    }
  },
  computed: {
    isLoggingIn() {
      return this.$store.state.Auth.isLoggingIn;
    },
    errors() {
      return this.$store.state.Auth.errors;
    }
  }
};
</script>
<style>
.btn-loader {
  width: auto;
  height: 20px;
}

.error-block {
  background: #f03d3d;
  font-size: 12px;
  font-weight: 500;
  border-radius: 50px;
  margin-top: 20px;
}

.submit-button {
  background: #f96322;
  width: 100%;
  padding: 15px 0;
  border-radius: 30px;
}
</style>
